<template lang="pug">
  .columns
    .column.is-12
      .columns
        .column.is-12(v-html="getTitle()")
      .columns.has-text-left
        .column.is-12
          .columns
            .column
              b Ubicación:&nbsp
              | {{ baja.destino }}
          .columns
            .column
              b Oficina:&nbsp
              | {{ baja.ofi_destino }}
</template>

<script>
  export default {
    name: 'CardBaja',
    props: {
      baja: {
        type: Object,
        default: () => {}
      },
      items: Array,
      default: []
    },
    data() {
      return {
      }
    },
    methods: {
      getTitle() {
        let htmlStr = ''
        switch (parseInt(this.baja.estado)) {
          case 1:
            htmlStr = `<b class="is-size-5">Firmar Realiza<br/>Baja: ${this.baja.clave_baja}</b>`
            break
          case 2:
            htmlStr = `<b class="is-size-5">Firmar Autoriza<br/>Baja: ${this.baja.clave_baja}</b>`
            break
          case 3:
            htmlStr = `<b class="is-size-5">Firmar Visto Bueno<br/>Baja: ${this.baja.clave_baja}</b>`
            break
        
          default:
            htmlStr = `${this.baja.clave_baja}`
            break
        }
        
        return htmlStr
      },
      getHash() {
        try {
          let res1 = this.baja.hash.substr(0,40)
          let res2 = this.baja.hash.substr(40,40)
          let res3 = this.baja.hash.substr(80,40)
          let res4 = this.baja.hash.substr(120,40)
          let res5 = this.baja.hash.substr(160,40)
          let res6 = this.baja.hash.substr(200)

          let htmlstr = `
          <div class="notification">
            <b>Sello Digital:</b><br/>
            ${res1}<br/>
            ${res2}<br/>
            ${res3}<br/>
            ${res4}<br/>
            ${res5}<br/>
            ${res6}
          </div>`
          return htmlstr  
        } catch (error) {
          console.log(error)
        }
        
      }
    },
    created () {
      
    },
  }
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/inventario_Componentes/CardBaja.vue